import React from "react";
import DropdownC from "../../../common/dropdown";
import styles from "./index.module.scss";
import {
  CallButtonClicked,
  EmailButtonClicked,
  TextButtonClicked
} from "../../../../utils/inv-exch-amplitude";
import { useSearchParams } from "react-router-dom";

export default function ContactDropdown({
  flipperData,
  hideInfo,
  contact,
  setContact
}: {
  flipperData: any;
  hideInfo: boolean;
  contact: any;
  setContact: any;
}) {
  const [searchParams] = useSearchParams();
  const pubPropertyId = searchParams.get("pid") ?? flipperData?.propertyId;
  const pubPropertySfid = searchParams.get("sfid") ?? flipperData?.propertySfid;
  return (
    <div>
      {hideInfo ? (
        <div className={styles.FlipperVaultContactDropdown}>
          <div className={styles.dropdownBoxExpired}>**********</div>
          <img src="/images/call.svg" alt="" className={styles.icon} />
          <img src="/images/email.svg" alt="" className={styles.icon} />
          <img
            src="/images/message.svg"
            alt=""
            className={styles.icon}
            width={20}
          />
        </div>
      ) : (
        <>
          {flipperData?.contacts?.[0] ? (
            <div className={styles.FlipperVaultContactDropdown}>
              {flipperData?.contacts.length > 1 ? (
                <DropdownC
                  showClear={false}
                  placeholder="Select Contact"
                  className={styles.dropdownBox}
                  options={flipperData?.contacts}
                  optionLabel="name"
                  panelClassName={styles.dropdownList}
                  onChange={(e: any) => setContact(e.value)}
                  value={contact}
                />
              ) : (
                <div className={styles.singleContact}>{contact?.name}</div>
              )}
              {/* {contact?.mobile && ( */}
                <button
                  className={styles.iconButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    CallButtonClicked({
                      property_id: pubPropertyId,
                      property_sfid: pubPropertySfid,
                      investor_sfid: flipperData?.acctSfid,
                      investor_id: flipperData?.acctId,
                      contact: {
                        ...contact
                      }
                    });
                    
                    window.location.href = `tel:${contact.mobile}`;
                  }}
                  aria-label="Call contact"
                >
                  <img src="/images/call.svg" alt="" />
                </button>
              {/* )} */}
              {/* {contsact?.email && ( */}
                <button
                  className={styles.iconButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    EmailButtonClicked({
                      property_id: pubPropertyId,
                      property_sfid: pubPropertySfid,
                      investor_sfid: flipperData?.acctSfid,
                      investor_id: flipperData?.acctId,
                      contact: {
                        ...contact
                      }
                    });
                    window.location.href = `mailto:${contact.email}`;
                  }}
                  aria-label="Email contact"
                >
                  <img src="/images/email.svg" alt="" />
                </button>
              {/* )} */}
              {/* {contact?.mobile && ( */}
                <button
                  className={styles.iconButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    TextButtonClicked({
                      property_id: pubPropertyId,
                      property_sfid: pubPropertySfid,
                      investor_sfid: flipperData?.acctSfid,
                      investor_id: flipperData?.acctId,
                      contact: {
                        ...contact
                      }
                    });
                    window.location.href = `sms:${contact.mobile}`;
                  }}
                  aria-label=" Call contact"
                >
                  <img src="/images/message.svg" alt="" width={20} />
                </button>
              {/* )} */}
            </div>
          ) : (
            <span
              style={{
                display: "block",
                height: "25px"
              }}
            >
              No Contact Found
            </span>
          )}
        </>
      )}
    </div>
  );
}
